import React from "react";
import { Link } from "react-router-dom";
import "../index.css"; 
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'bootstrap-icons/font/bootstrap-icons.css';

export default function TeamCard({ member }) {
  const link = `/team/${member.id}`;
  return (
    <Link to={link} className="text-decoration-none text-reset">
            <div className="team-item">
                <div className="overflow-hidden">
                    <img
                    src={`https://node.lcwe-lb.com/uploads/images/${member.photo}`}
                    alt={member.name}
                    className="img-fluid"
                    />
                </div>
                <div className="position-relative d-flex justify-content-center" style={{marginTop:"-23px"}}>
                    <div className="bg-light d-flex justify-content-center pt-2 px-1">
                        <a className="btn btn-sm-square btn-primary mx-1" href=""><i className="bi bi-twitter"></i></a>
                    </div>
                </div>
                <div className="text-center p-4">
                    <h5 className="mb-0">{member.name}</h5>
                    <small>{member.position}</small>
                </div>

            </div>
    </Link>
  );
}
